import React, { useContext, useEffect, useState } from 'react';
import { TableCell, TableRow } from '../shadcn/ui/table';
import { ContactCard } from '@/pages/clients/client_components/contactCard';
import { ClientContact } from '@/entities/clientContact';
import CardContact from '@/pages/clients/client_components/CardContact';
import CepFormatter from '@/utils/cepFormater';
import CustomInputPhoneMask from '@/utils/customInputPhoneMask';
import { useClients } from '@/hook/useClients';
import { useClientContext } from '@/context/ClientContext';

interface Contact{
  idContato: number;
  nomeContato: string;
  celular: string;
  clientId: number;
  fixo: string;
  email: string;
  funcao: string;
}

interface ContactFormData{
  id: number,
  name: string,
  phone: string,
  clientId: number,
  email: string;
  cellPhone: string,
  function: string
}

interface ClientFormDataContato {
  id: number;
  nomefantasia: string;
  razao: string;
  ramo: string;
  status: string;
  cpfOrCnpj: string;
  //contato
  contatos: Contact[] | [];
  //endereco
  cep: string;
  rua: string;
  cidade: string;
  uf: string;
  bairro: string;
  numero: string;
}

type InnerTableProps = {
  dataContato: ClientFormDataContato;
}

const InnerTable: React.FC<InnerTableProps> = ({ dataContato }) => {
  const { getContactList, deleteContact, contatos, setContatos } = useClients();

  {/* eslint-disable-next-line */}
  const onDelete = (id:number) => {
    deleteContact(id);
  };
  {/* eslint-disable-next-line */}
  const onEdit = (contact:ClientContact) => {}

  const fetchContacts = async () => {
    const contact1 = await getContactList(dataContato.id);
    setContatos(contact1);
  };
  
  useEffect(()=>{
    fetchContacts();
  },[]);

  return (
    <>
      {/** Parte de Contato do Cliente */}
      {/** dados */}
      <TableRow className='relative bg-indigo-50'>
        <TableCell colSpan={6}>
            
          <div className='w-[400px] max-w-[500px] relative grid grid-cols-1 mt-4 mx-2 px-4 pt-4 gap-4 -top-6 border-l-2 border-indigo-200'>

            {/** Contato */}
            <div className='flex flex-col gap-2'>
              {contatos.map((contato, index) => (
                <CardContact key={contato.id} contact={contato} onDelete={onDelete} onEdit={onEdit} index={index} />
              ))}
            </div>

            {/** Endereço */}
            <div className='flex flex-col gap-2'>
              <h2 className='text-xs font-extralight'>Endereço</h2>
              <div className='flex items-center gap-4'>
                <p className='text-xs font-extralight'>CEP</p>
                <p>{dataContato.cep.length === 8 ? CepFormatter.formatarCep(dataContato.cep) : 'Edite as informações do seu cliente para adicionar endereço'}</p>
              </div>
              <div className='flex items-center gap-4'>
                <p className='text-xs font-extralight'>Rua</p>
                <p>{dataContato.rua || ''}</p>
              </div>
              <div className='flex items-center gap-4'>
                <p className='text-xs font-extralight'>Bairro</p>
                <p>{dataContato.bairro || ''}</p>
              </div>
              <div className='flex items-center gap-4'>
                <p className='text-xs font-extralight'>Cidade/Estado</p>
                <p>{dataContato.cidade || ''} - {dataContato.uf|| ''} </p>
              </div>
              <div className='flex items-center gap-4'>
                <p className='text-xs font-extralight'>Número</p>
                <p>{CustomInputPhoneMask.format(dataContato.numero) || ''}</p>
              </div>
            </div>
          </div>
        </TableCell>
      </TableRow>
    </>
  );
};

export default InnerTable;
